module.exports = __webpack_public_path__ + "img/246.Explain_process.c3c0606f.svg";